import { useSuspenseQuery } from '@tanstack/react-query';
import useApi from '../useApi';
import { LICENSE_QUERY_KEYS } from './keys';
import type { AssetLicenseResponse } from '../../../../types/isomorphic/license.types';

interface UseAssetLicensedParams {
  asset: { id: string; isRestricted: () => boolean };
  isBulkDownload: boolean;
}

const useAssetLicensed = ({
  asset,
  isBulkDownload,
}: UseAssetLicensedParams) => {
  const { licenseService } = useApi();
  const { id } = asset;

  const fetchAssetLicense = async (): Promise<AssetLicenseResponse | null> => {
    if (!isBulkDownload && !asset.isRestricted()) {
      // Prevent making an API call if we're handling batch asset downloads and if the asset is restricted
      const result = await licenseService.getActiveLicense(id);
      return result;
    }
    return null;
  };

  const query = useSuspenseQuery<AssetLicenseResponse | null>({
    queryKey: LICENSE_QUERY_KEYS.assetLicense(id),
    queryFn: () => fetchAssetLicense(),
  });
  return { ...query, response: query.data };
};

export default useAssetLicensed;
